import { useNavigate, useParams } from 'react-router-dom'
import { BusinessSelector } from '@/components/BusinessSelector'
import { DocumentList } from '@/components/DocumentList'
import { DocumentDetail } from '@/components/DocumentDetail'
import { useBusinessContext } from '@/context/BusinessContext'
import { useDocumentDrop } from '@/hooks/useDocumentDrop'
import { DragOverlay } from '@/components/Upload/DragOverlay'

export function DocumentsPage() {
  const { selectedBusinessId } = useBusinessContext()
  const navigate = useNavigate()
  // The selected document id comes from the URL (/documents/:documentId),
  // which makes the detail view directly addressable and shareable.
  const { documentId } = useParams<{ documentId: string }>()
  const selectedDocumentId = documentId ?? null
  const { isDragging, containerProps } = useDocumentDrop({ enabled: !!selectedBusinessId })

  const handleDocumentSelect = (id: string) => {
    navigate(`/documents/${id}`)
  }

  const handleBack = () => {
    navigate('/documents')
  }

  return (
    <div data-testid="documents-page" {...containerProps}>
      <DragOverlay visible={isDragging} />
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold text-gray-900">Expenses</h1>
            <BusinessSelector />
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        {!selectedBusinessId ? (
          <div className="text-center py-12">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
              />
            </svg>
            <h3 className="mt-2 text-sm font-medium text-gray-900">No business selected</h3>
            <p className="mt-1 text-sm text-gray-500">
              Select a business from the dropdown above to view documents.
            </p>
          </div>
        ) : selectedDocumentId ? (
          <DocumentDetail
            documentId={selectedDocumentId}
            onBack={handleBack}
            onDocumentSelect={handleDocumentSelect}
          />
        ) : (
          <DocumentList
            businessId={selectedBusinessId}
            onDocumentSelect={handleDocumentSelect}
          />
        )}
      </main>
    </div>
  )
}
